export const getLinkProps = (href, target) => ({
  href,
  rel: target === '_blank' ? 'noopener noreferrer' : null,
  target
});
export const getButtonProps = onClick => ({
  type: 'button',
  onClick
});
export const getCustomElement = (isDisabled, href, onClick) => {
  if (href && !isDisabled) {
    return 'a';
  }
  if (onClick || isDisabled) {
    return 'button';
  }
  return 'span';
};